var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jp-common-layout " }, [
    _c(
      "div",
      { staticClass: "jp-common-layout-left", staticStyle: { width: "370px" } },
      [
        _c(
          "div",
          { staticClass: "jp-common-title flexTreeTitle" },
          [
            _c("el-input", {
              staticStyle: { width: "245px" },
              attrs: {
                placeholder: "请输入关键字进行过滤",
                size: "small",
                clearable: "",
              },
              model: {
                value: _vm.filterText,
                callback: function ($$v) {
                  _vm.filterText = $$v
                },
                expression: "filterText",
              },
            }),
            _c(
              "div",
              [
                _c("el-button", {
                  attrs: {
                    size: "small",
                    type: "primary",
                    circle: "",
                    icon: "el-icon-search",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.searchTree("search")
                    },
                  },
                }),
                _c("el-button", {
                  attrs: {
                    size: "small",
                    type: "primary",
                    circle: "",
                    icon: "fa fa-random",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.searchTree("expandAll")
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "jp-common-el-tree-scrollbar el-scrollbar" }, [
          _c(
            "div",
            {
              staticClass: "el-scrollbar__wrap",
              style: { height: _vm.treeHeight - 40 + "px", marginTop: "20px" },
            },
            [
              _c(
                "div",
                { staticClass: "el-scrollbar__view" },
                [
                  _c(
                    "vxe-table",
                    {
                      ref: "xTree",
                      attrs: {
                        "show-overflow": "",
                        border: "none",
                        loading: _vm.loading,
                        "show-header": false,
                        "tree-config": {
                          transform: true,
                          rowField: "id",
                          parentField: "parentId",
                          expandAll: _vm.treeExpandAll,
                          reserve: true,
                        },
                        "radio-config": { labelField: "nameCn" },
                        "row-config": {
                          keyField: "id",
                          isCurrent: true,
                          isHover: true,
                        },
                        data: _vm.showTreeList,
                      },
                    },
                    [
                      _c("vxe-column", {
                        attrs: { field: "nameCn", "tree-node": "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "treeSpan",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handRow(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.name))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ]),
      ]
    ),
    _c("div", { staticClass: "jp-common-layout-center jp-flex-main" }, [
      _c(
        "div",
        { staticClass: "page" },
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              staticClass: "query-form",
              attrs: { size: "small", inline: true, model: _vm.searchForm },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.refreshList()
                },
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "proCode" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "项目编号",
                      clearable: "",
                    },
                    model: {
                      value: _vm.searchForm.proCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "proCode", $$v)
                      },
                      expression: "searchForm.proCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "name" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "项目名称",
                      clearable: "",
                    },
                    model: {
                      value: _vm.searchForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "name", $$v)
                      },
                      expression: "searchForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "kindId1" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: { clearable: "", placeholder: "工程类别" },
                      on: { change: _vm.handCategories },
                      model: {
                        value: _vm.searchForm.kindId1,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "kindId1", $$v)
                        },
                        expression: "searchForm.kindId1",
                      },
                    },
                    _vm._l(_vm.kindCategoriesList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "kindId2" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: { clearable: "", placeholder: "工程类型" },
                      model: {
                        value: _vm.searchForm.kindId2,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "kindId2", $$v)
                        },
                        expression: "searchForm.kindId2",
                      },
                    },
                    _vm._l(_vm.kindTypeList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "workUnitId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: { clearable: "", placeholder: "施工单位" },
                      model: {
                        value: _vm.searchForm.workUnitId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "workUnitId", $$v)
                        },
                        expression: "searchForm.workUnitId",
                      },
                    },
                    _vm._l(
                      _vm.$dictUtils.getDictList("cec_build_section"),
                      function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-search",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.refreshList()
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-refresh-right" },
                      on: {
                        click: function ($event) {
                          return _vm.resetSearch()
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "bg-white top" },
            [
              _c("vxe-toolbar", {
                scopedSlots: _vm._u([
                  {
                    key: "buttons",
                    fn: function () {
                      return [
                        _vm.hasPermission("cecproject:cecproject:getproject")
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  type: "success",
                                  icon: "el-icon-refresh-right",
                                  loading: _vm.loading,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getCecProject()
                                  },
                                },
                              },
                              [_vm._v("获取CEC项目数据")]
                            )
                          : _vm._e(),
                        _vm.hasPermission("cecproject:cecproject:getKind")
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  type: "success",
                                  icon: "el-icon-refresh-right",
                                  loading: _vm.loading,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getCecDataSheet("Kind")
                                  },
                                },
                              },
                              [_vm._v("获取CEC项目类别类型数据")]
                            )
                          : _vm._e(),
                        _vm.hasPermission("cecproject:cecproject:getCategory")
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  type: "success",
                                  icon: "el-icon-refresh-right",
                                  loading: _vm.loading,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getCecDataSheet("Category")
                                  },
                                },
                              },
                              [_vm._v("获取CEC项目物品类型数据")]
                            )
                          : _vm._e(),
                        _vm.hasPermission("cecproject:cecproject:getUnit")
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  type: "success",
                                  icon: "el-icon-refresh-right",
                                  loading: _vm.loading,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getCecDataSheet("Unit")
                                  },
                                },
                              },
                              [_vm._v("获取CEC项目物品单位数据")]
                            )
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c(
                "div",
                { staticStyle: { height: "calc(100% - 130px)" } },
                [
                  _c(
                    "vxe-table",
                    {
                      ref: "cecProjectTable",
                      attrs: {
                        border: "full",
                        "auto-resize": "",
                        resizable: "",
                        height: "auto",
                        loading: _vm.loading,
                        size: "small",
                        "show-header-overflow": "",
                        "show-overflow": "",
                        "highlight-hover-row": "",
                        "scroll-y": { enabled: true },
                        "menu-config": {},
                        "print-config": {},
                        "import-config": {
                          importMethod: _vm.importMethod,
                          types: ["csv", "xls", "xlsx"],
                          remote: true,
                        },
                        "export-config": {
                          remote: true,
                          filename:
                            "项目表数据" +
                            _vm.moment(new Date()).format("YYYY-MM-DD"),
                          sheetName: "项目表数据",
                          exportMethod: _vm.exportMethod,
                          types: ["xlsx"],
                          modes: ["current", "selected", "all"],
                        },
                        "sort-config": { remote: true },
                        data: _vm.dataList,
                        "checkbox-config": {},
                      },
                      on: { "sort-change": _vm.sortChangeHandle },
                    },
                    [
                      _c("vxe-column", {
                        attrs: {
                          type: "checkbox",
                          width: "40px",
                          align: "center",
                          fixed: "left",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          type: "seq",
                          width: "50",
                          fixed: "left",
                          align: "center",
                          title: "序号",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "proCode",
                          fixed: "left",
                          align: "center",
                          width: "150",
                          title: "项目编号",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.hasPermission("cecproject:cecProject:view")
                                  ? _c(
                                      "el-link",
                                      {
                                        attrs: {
                                          type: "primary",
                                          underline: false,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.view(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row.proCode))]
                                    )
                                  : _c("span", [
                                      _vm._v(_vm._s(scope.row.proCode)),
                                    ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "name",
                          fixed: "left",
                          align: "center",
                          width: "100",
                          title: "项目名称",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "kindName1",
                          width: "100",
                          align: "center",
                          title: "工程类别",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "kindName2",
                          width: "100",
                          align: "center",
                          title: "工程类型",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "workPoint",
                          width: "150",
                          align: "center",
                          title: "施工指示",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "workNote",
                          width: "150",
                          align: "center",
                          title: "注意事项",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "workUnitId",
                          width: "100",
                          align: "center",
                          title: "施工小组",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.setWorkUnitText(scope.row.workUnitId)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "otherProjectId",
                          width: "80",
                          align: "center",
                          title: "涉及项目",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                !scope.row.otherProjectId
                                  ? _c("div", [_vm._v(" - ")])
                                  : _c("PopoverTipList", {
                                      attrs: {
                                        labelValue: "id",
                                        tableType: "length",
                                        value: scope.row.otherProjectId,
                                        sortDisabled: true,
                                        columns: [
                                          {
                                            prop: "proCode",
                                            label: "项目编号",
                                          },
                                          {
                                            prop: "kindName1",
                                            label: "工程类别",
                                          },
                                          {
                                            prop: "kindName2",
                                            label: "工程类型",
                                          },
                                          {
                                            prop: "name",
                                            label: "工程项目",
                                          },
                                        ],
                                        selectArray: scope.row.others,
                                      },
                                    }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "picture",
                          width: "200",
                          align: "center",
                          title: "图片",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.picJsonList.length > 0
                                  ? _c("PopoverTipList", {
                                      attrs: {
                                        labelValue: "id",
                                        tableType: "length",
                                        tableHeight: "500px",
                                        boxWidth: "400",
                                        imageDisabled: true,
                                        columns: [
                                          {
                                            prop: "description",
                                            label: "描述",
                                          },
                                        ],
                                        selectArray: scope.row.picJsonList,
                                      },
                                    })
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "remarks",
                          align: "center",
                          "min-width": "100",
                          title: "备注",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("vxe-pager", {
                    attrs: {
                      background: "",
                      size: "small",
                      "current-page": _vm.tablePage.currentPage,
                      "page-size": _vm.tablePage.pageSize,
                      total: _vm.tablePage.total,
                      "page-sizes": [
                        10,
                        20,
                        100,
                        1000,
                        { label: "全量数据", value: 1000000 },
                      ],
                      layouts: [
                        "PrevPage",
                        "JumpNumber",
                        "NextPage",
                        "FullJump",
                        "Sizes",
                        "Total",
                      ],
                    },
                    on: { "page-change": _vm.currentChangeHandle },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("CecProjectForm", {
            ref: "cecProjectForm",
            on: { refreshDataList: _vm.refreshList },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }